import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/accessibility-feedback',
    name: 'AccessibilityFeedback',
    component: () => import('@/modules/accessibilityFeedback/views/FeedbackForm.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/feedback-success',
    name: 'FeedbackSuccessPage',
    component: () => import('@/modules/accessibilityFeedback/views/FeedbackSuccessPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
